export const KEY_UPLOADING_FILES_IN_LOCAL_STORAGE = 'uploading_files';
export const KEY_PROCESSING_FILES_IN_LOCAL_STORAGE = 'processing_files';
export const PARALLEL_UPLOADS = 5;
